import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Typography, useMediaQuery, Card, CardContent, CardActions, Rating, Button, Collapse, useTheme, InputBase, IconButton, Divider } from "@mui/material"
import Header from './Header'
import FlexBetween from './FlexBetween'
import { UserAuth } from '../context/AuthContext'
import { useNavigate } from 'react-router-dom'
import { motion } from "framer-motion";
import Grid from '@mui/material/Unstable_Grid2';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import FavoriteIcon from '@mui/icons-material/Favorite';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import SchoolIcon from '@mui/icons-material/School';
import SynagogueIcon from '@mui/icons-material/Synagogue';
import BallotIcon from '@mui/icons-material/Ballot';
import ScienceIcon from '@mui/icons-material/Science';
import Groups3Icon from '@mui/icons-material/Groups3';
import Person4Icon from '@mui/icons-material/Person4';
import InfoIcon from '@mui/icons-material/Info';
import ModalInfoAdicional from './modales/ModalInfoAdicional'

const AreaAcademica = () => {
    const theme = useTheme()
    const [abrirInfo, setAbrirInfo] = React.useState(false)

    //abrir modal
    const handleOpenInfo = () => {
        setAbrirInfo(true)
    }
    //cerrar modal
    const handleCloseInfo = () => {
        setAbrirInfo(false)
    }

    //submit del formulario del modal
    const handleSubmit = (objeto) => {
        console.log(objeto)
        // if (token !== '') {
        //     dispatch((dispatch) => {
        //         dispatch(nuevaGestion(empleado.empleadoid, objeto, token))
        //             .then(() => {
        //                 // Actualiza la tabla cuando se cumple la promesa
        //                 dispatch(misGestionesAbiertas(token, empleado.empleadoid))
        //                 handleCloseModalTable()
        //             });
        //     });
        // }
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box
                m="1.5rem 2.5rem"
            >
                <Header title={"Área Académica"} subtitle="En este espacio deberá completar toda la información académica que la Universidad necesita." />
                <Box sx={{ mt: 4 }}>

                    <Accordion sx={{ backgroundColor:  theme.palette.mode === 'dark' ? theme.palette.primary.main  : theme.palette.tertiary[600] }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Box display="flex" alignItems="center"> {/* Use a Box to align icon and title in the same row */}
                                <IconButton>
                                    <AssignmentIcon sx={{ fontWeight: 'bold', color: '#fff' }} /> {/* Your desired icon on the left side */}
                                </IconButton>
                                <Typography sx={{ color: '#fff' }}>Formación</Typography> {/* The title */}
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                                malesuada lacus ex, sit amet blandit leo lobortis eget.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion sx={{ backgroundColor:  theme.palette.mode === 'dark' ? theme.palette.primary.main  : theme.palette.tertiary[600] }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Box display="flex" alignItems="center"> {/* Use a Box to align icon and title in the same row */}
                                <IconButton>
                                    <SupervisedUserCircleIcon sx={{ fontWeight: 'bold', color: '#fff' }} /> {/* Your desired icon on the left side */}
                                </IconButton>
                                <Typography sx={{ color: '#fff' }}>Área principal de desempeño de profesional</Typography> {/* The title */}
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                                malesuada lacus ex, sit amet blandit leo lobortis eget.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion sx={{ backgroundColor:  theme.palette.mode === 'dark' ? theme.palette.primary.main  : theme.palette.tertiary[600] }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Box display="flex" alignItems="center"> {/* Use a Box to align icon and title in the same row */}
                                <IconButton>
                                    <SchoolIcon sx={{ fontWeight: 'bold', color: '#fff' }} /> {/* Your desired icon on the left side */}
                                </IconButton>
                                <Typography sx={{ color: '#fff' }}>Docencia univeritaria</Typography> {/* The title */}
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                                malesuada lacus ex, sit amet blandit leo lobortis eget.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion sx={{ backgroundColor:  theme.palette.mode === 'dark' ? theme.palette.primary.main  : theme.palette.tertiary[600] }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Box display="flex" alignItems="center"> {/* Use a Box to align icon and title in the same row */}
                                <IconButton>

                                    <SynagogueIcon sx={{ fontWeight: 'bold', color: '#fff' }} /> {/* Your desired icon on the left side */}
                                </IconButton>
                                <Typography sx={{ color: '#fff' }}>Gestión académica</Typography> {/* The title */}
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                                malesuada lacus ex, sit amet blandit leo lobortis eget.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion sx={{ backgroundColor:  theme.palette.mode === 'dark' ? theme.palette.primary.main  : theme.palette.tertiary[600] }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Box display="flex" alignItems="center"> {/* Use a Box to align icon and title in the same row */}
                                <IconButton>

                                    <BallotIcon sx={{ fontWeight: 'bold', color: '#fff' }} /> {/* Your desired icon on the left side */}
                                </IconButton>
                                <Typography sx={{ color: '#fff' }}>Desempeño no académico</Typography> {/* The title */}
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                                malesuada lacus ex, sit amet blandit leo lobortis eget.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion sx={{ backgroundColor:  theme.palette.mode === 'dark' ? theme.palette.primary.main  : theme.palette.tertiary[600] }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Box display="flex" alignItems="center"> {/* Use a Box to align icon and title in the same row */}
                                <IconButton>
                                    <ScienceIcon sx={{ fontWeight: 'bold', color: '#fff' }} /> {/* Your desired icon on the left side */}
                                </IconButton>
                                <Typography sx={{ color: '#fff' }}>Investigación</Typography> {/* The title */}
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                                malesuada lacus ex, sit amet blandit leo lobortis eget.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion sx={{ backgroundColor:  theme.palette.mode === 'dark' ? theme.palette.primary.main  : theme.palette.tertiary[600] }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Box display="flex" alignItems="center"> {/* Use a Box to align icon and title in the same row */}
                                <IconButton>

                                    <Groups3Icon sx={{ fontWeight: 'bold', color: '#fff' }} /> {/* Your desired icon on the left side */}
                                </IconButton>
                                <Typography sx={{ color: '#fff' }}>Reuniones científicas</Typography> {/* The title */}
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                                malesuada lacus ex, sit amet blandit leo lobortis eget.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion sx={{ backgroundColor:  theme.palette.mode === 'dark' ? theme.palette.primary.main  : theme.palette.tertiary[600] }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Box display="flex" alignItems="center"> {/* Use a Box to align icon and title in the same row */}
                                <IconButton>

                                    <Person4Icon sx={{ fontWeight: 'bold', color: '#fff' }} /> {/* Your desired icon on the left side */}
                                </IconButton>
                                <Typography sx={{ color: '#fff' }}>Comités y jurados</Typography> {/* The title */}
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                                malesuada lacus ex, sit amet blandit leo lobortis eget.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion sx={{ backgroundColor:  theme.palette.mode === 'dark' ? theme.palette.primary.main  : theme.palette.tertiary[600] }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Box display="flex" alignItems="center">
                                <IconButton>

                                    <InfoIcon sx={{ fontWeight: 'bold', color: '#fff' }} />
                                </IconButton>
                                <Typography sx={{ color: '#fff' }}>Otra información</Typography>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Button variant="contained" color='primary' onClick={handleOpenInfo}>
                                Cargar información adicional
                            </Button>
                        </AccordionDetails>
                    </Accordion>
                </Box>
            </Box>
            <ModalInfoAdicional open={abrirInfo} handleClose={handleCloseInfo} onSubmit={handleSubmit} />
        </motion.div>
    )
}

export default AreaAcademica